import { experimentNumberByDate, getExperiments } from "../../lab";
import { formatDate } from "../../lib/format";
import { FeaturedIndexItem } from "./FeaturedIndex";

const LAB_PREVIEWS: Record<string, string> = {
	boids: "/lab/boids.webp",
	sierpinski: "/lab/sierpinski.webp",
	perlin: "/lab/perlin.webp",
};

export function labFeaturedItems(
	experiments: Array<{
		id: string;
		date: string;
		title: string;
		summary: string;
		kicker: string;
	}>,
	lang: string,
	cta: string,
): FeaturedIndexItem[] {
	return getExperiments(experiments).map((experiment) => ({
		id: experiment.id,
		href: `/lab/${experiment.id}`,
		title: experiment.title,
		excerpt: experiment.summary,
		cover: LAB_PREVIEWS[experiment.id],
		number: experimentNumberByDate(experiments, experiment.id),
		eyebrow: experiment.kicker,
		aside: formatDate(experiment.date, lang),
		dateTime: experiment.date,
		cta,
	}));
}
